// src/pages/TermsPage.js
import React from 'react';
import { Container, Typography, Link, Divider, List, ListItem } from '@mui/material';

const LAST_UPDATED = '17 Eylül 2025';
const CONTACT_EMAIL = 'info@suzmesayac.com';

export default function TermsPage() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>Kullanım Şartları (Terms of Use)</Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Son güncelleme: {LAST_UPDATED}
      </Typography>

      <Typography paragraph>
        Bu uygulamayı (<strong>Süzme Sayaç</strong>) kullanarak aşağıdaki şartları kabul etmiş olursunuz.
      </Typography>

      <Divider sx={{ my: 2 }} />

      <Typography variant="h6" gutterBottom>Hizmet Tanımı</Typography>
      <Typography paragraph>
        Süzme Sayaç, elektrik tüketimlerini alt sayaçlarla adil biçimde paylaşmayı sağlayan bir yazılımdır.
      </Typography>

      <Typography variant="h6" gutterBottom>Kullanım Kuralları</Typography>
      <List dense>
        <ListItem disableGutters>• Uygulama yalnızca yasal amaçlarla kullanılabilir.</ListItem>
        <ListItem disableGutters>• Hesap bilgilerinizin gizliliğinden siz sorumlusunuz.</ListItem>
        <ListItem disableGutters>• Hizmet kesintisiz çalışmayı garanti etmez; bakım ve güncellemeler yapılabilir.</ListItem>
      </List>

      <Typography variant="h6" gutterBottom>Abonelikler ve Ödemeler</Typography>
      <List dense>
        <ListItem disableGutters>• Bazı özellikler abonelik veya tek seferlik satın alma ile sunulabilir.</ListItem>
        <ListItem disableGutters>• Satın almalar App Store ve Google Play üzerinden yapılır, ilgili mağaza politikalarına tabidir.</ListItem>
        <ListItem disableGutters>• Yenileme/iptal koşulları mağazaların kurallarına göre belirlenir.</ListItem>
      </List>

      <Typography variant="h6" gutterBottom>Gizlilik</Typography>
      <Typography paragraph>
        Gizlilik politikamız için:{" "}
        <Link href="https://suzmesayac.com/privacy" target="_blank" rel="noreferrer">
          Gizlilik Politikası
        </Link>
      </Typography>

      <Typography variant="h6" gutterBottom>Apple Kullanıcıları</Typography>
      <Typography paragraph>
        iOS cihazlarda uygulamayı kullanarak{" "}
        <Link
          href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
          target="_blank"
          rel="noreferrer"
        >
          Apple Standard End User License Agreement (EULA)
        </Link>{" "}
        şartlarını da kabul etmiş olursunuz.
      </Typography>

      <Typography variant="h6" gutterBottom>Android Kullanıcıları</Typography>
      <Typography paragraph>
        Android cihazlarda bu sayfada belirtilen kullanım şartları geçerlidir.
      </Typography>

      <Typography variant="h6" gutterBottom>İletişim</Typography>
      <Typography paragraph>
        Sorularınız için{" "}
        <Link href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Link>{" "}
        adresinden bize ulaşabilirsiniz.
      </Typography>

      <Divider sx={{ my: 3 }} />

      <Typography variant="h5" gutterBottom>English</Typography>

      <Typography variant="h6" gutterBottom>Service Description</Typography>
      <Typography paragraph>
        Süzme Sayaç enables fair sharing of electricity consumption using sub-meters.
      </Typography>

      <Typography variant="h6" gutterBottom>Usage Rules</Typography>
      <List dense>
        <ListItem disableGutters>• The app must be used for lawful purposes only.</ListItem>
        <ListItem disableGutters>• You are responsible for securing your account credentials.</ListItem>
        <ListItem disableGutters>• Service availability is not guaranteed; maintenance and updates may occur.</ListItem>
      </List>

      <Typography variant="h6" gutterBottom>Subscriptions & Payments</Typography>
      <List dense>
        <ListItem disableGutters>• Some features are offered via subscription or one-time purchase.</ListItem>
        <ListItem disableGutters>• Purchases are managed by Apple App Store and Google Play.</ListItem>
        <ListItem disableGutters>• Cancellation and billing rules follow the respective store’s policies.</ListItem>
      </List>

      <Typography variant="h6" gutterBottom>Privacy</Typography>
      <Typography paragraph>
        Please see our{" "}
        <Link href="https://suzmesayac.com/privacy" target="_blank" rel="noreferrer">
          Privacy Policy
        </Link>.
      </Typography>

      <Typography variant="h6" gutterBottom>For Apple Users</Typography>
      <Typography paragraph>
        On iOS you also agree to the{" "}
        <Link
          href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
          target="_blank"
          rel="noreferrer"
        >
          Apple Standard EULA
        </Link>.
      </Typography>

      <Typography variant="h6" gutterBottom>For Android Users</Typography>
      <Typography paragraph>
        On Android, the Terms on this page apply.
      </Typography>

      <Typography variant="h6" gutterBottom>Contact</Typography>
      <Typography paragraph>
        Questions:{" "}
        <Link href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Link>
      </Typography>
    </Container>
  );
}
